export const RESIDENT_STATUS_OPTIONS = [
  {
    value: 'active',
    label: `Active `,
  },
  {
    value: 'inactive',
    label: `Inactive`,
  },
  {
    value: 'hospitalised',
    label: `Hospitalised`,
  },
  {
    value: 'deceased',
    label: `Deceased`,
  },
  {
    value: 'discharged',
    label: `Discharged`,
  },
]

export const PERSONAL_INFO_FIELDS = [
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'gender',
    label: 'Gender',
  },
  {
    key: 'dateOfBirth',
    label: 'Date of birth',
  },
  {
    key: 'maritalStatus',
    label: 'Marital status',
  },
  {
    key: 'birthplace',
    label: 'Birthplace',
  },
  {
    key: 'nationalities',
    label: 'Nationalities',
  },
  {
    key: 'languagesSpoken',
    label: 'Language(s) spoken',
  },
  {
    key: 'ethnicity',
    label: 'Ethnicity',
  },
  {
    key: 'religion',
    label: 'Religion',
  },
  {
    key: 'carerGender',
    label: 'Carer Gender Preference',
  },
  {
    key: 'carerNotes',
    label: 'Carer Note',
  },
]

export const PRO_CARE_RELATED_FIELDS = [
  {
    key: 'dnacpr',
    label: 'DNACPR',
  },
  {
    key: 'dnacprForm',
    label: 'DNACPR form',
  },
  {
    key: 'dols',
    label: 'LPS',
  },
  {
    key: 'hasChokingRisk',
    label: 'Risk of choking',
  },
  {
    key: 'bloodType',
    label: 'Blood Type',
  },
  {
    key: 'medicalHistory',
    label: 'Medical History',
  },
  {
    key: 'admissionDate',
    label: 'Admission date',
  },
  {
    key: 'nationalInsurance',
    label: 'National Insurance number',
  },
  {
    key: 'nhsNumber',
    label: 'NHS number',
    altLabel: 'Health Care Number',
  },
  {
    key: 'otherIdentifierType',
    label: 'Other Identifier type',
  },
  {
    key: 'fundingSource',
    label: 'Funding source',
  },
  {
    key: 'fundingSourceOther',
    label: 'Other funding source',
  },
  {
    key: 'height',
    label: 'Height (cm)',
  },
]

export const EMAR_CARE_RELATED_FIELDS = [
  {
    key: 'preferredAdminRoute',
    label: 'Tablets in hand/pot/mouth',
  },
  {
    key: 'preferredDrink',
    label: 'Preferred drink',
  },
  {
    key: 'prnMedsNote',
    label: 'PRN meds',
  },
]

export const SITE_RELATED_FIELDS = [
  {
    key: 'zone',
    label: 'Zone',
  },
  {
    key: 'building',
    label: 'Building',
  },
  {
    key: 'floor',
    label: 'Floor',
  },
  {
    key: 'room',
    label: 'Room',
  },
  {
    key: 'bed',
    label: 'Bed',
  },
  {
    key: 'carers',
    label: 'Care Team',
  },
  {
    key: 'keyworkers',
    label: 'Keyworkers',
  },
]
